import { ACTIONS } from '../../../util/constants';
import { createVirtualLink } from '../../../util/createVirtualLink';
import logger from '../../../util/logging.client';
import { getAccountOTCInfo } from '../../Verification-Modals/Account-Verification-Modal/accountVerification.util';
import { getUsernameOTCInfo } from '../../Verification-Modals/Login-Verification-Modal/loginVerification.util';

/**
 * @name handleAction - Handles actions based on action defined in strapi
 * @param {string} action - Action type to perform
 * @param {string} redirectUrl - Redirection URl provided in strapi for specfic action
 * @param  {Array} states -Handles states passed from parent
 */
export const handleAction = async (action, redirectUrl, ...states) => {
  const {
    SWEEPR_TROUBLESHOOT,
    SWEEPR_VERIFY_LOGIN,
    SWEEPR_VERIFY_ACCOUNT,
    SWEEPR_VERIFY_SWITCH_TO_LOGIN,
    SWEEPR_VERIFY_SWITCH_TO_ACCOUNT,
    GENERIC_REDIRECT,
    GENERIC_CALL_DIALER,
    ERROR_TRY_AGAIN,
    ERROR_CLOSE,
  } = ACTIONS;
  const [
    router,
    showLoginVerificationModal,
    showAccountVerificationModal,
    graphql,
    executeRecaptcha,
    email,
    password,
    accountNumber,
    landLineNumber,
    captchaV2,
    setEnableCaptchaV2,
    setApiError,
    setDisableCTA,
    showMobileSupportModal,
    showBroadbandSupportModal,
    showEirSupportModal,
    setSweeprParams,
    setErrorCount,
  ] = states;

  switch (action) {
    case SWEEPR_TROUBLESHOOT:
      showLoginVerificationModal.enable();
      setErrorCount(0);
      break;
    case SWEEPR_VERIFY_LOGIN:
      {
        setErrorCount(0);
        const recaptchaV3Token = await executeRecaptcha();
        await getUsernameOTCInfo(
          graphql,
          recaptchaV3Token,
          email,
          password,
          captchaV2,
          setEnableCaptchaV2,
          setApiError,
          setDisableCTA,
          showMobileSupportModal,
          showLoginVerificationModal,
          showBroadbandSupportModal,
          showEirSupportModal,
          setSweeprParams,
        );
      }
      break;
    case SWEEPR_VERIFY_ACCOUNT:
      {
        setErrorCount(0);
        const recaptchaV3Token = await executeRecaptcha();
        await getAccountOTCInfo(
          graphql,
          recaptchaV3Token,
          accountNumber,
          landLineNumber,
          captchaV2,
          setEnableCaptchaV2,
          setApiError,
          setDisableCTA,
          showMobileSupportModal,
          showAccountVerificationModal,
          showBroadbandSupportModal,
          showEirSupportModal,
          setSweeprParams,
        );
      }
      break;
    case SWEEPR_VERIFY_SWITCH_TO_ACCOUNT:
      showAccountVerificationModal.enable();
      showLoginVerificationModal.disable();
      break;
    case SWEEPR_VERIFY_SWITCH_TO_LOGIN:
      showAccountVerificationModal.disable();
      showLoginVerificationModal.enable();
      break;
    case GENERIC_REDIRECT:
      createVirtualLink(redirectUrl);
      break;
    case GENERIC_CALL_DIALER:
      router.push(`tel:${redirectUrl}`);
      break;
    case ERROR_TRY_AGAIN:
      try {
        const widget = window.sweeprWidget;
        if (widget) {
          widget.showSupportHomescreen();
          widget.showWidget();
        } else {
          /**
           * @function reInitializeSweeprWidget
           * @description To re-initialize sweepr widget when OTC changes
           */
          const reInitializeSweeprWidget = () => {
            window.sweeprWidgetBuilt = false;
            // eslint-disable-next-line no-undef
            window.SweeprWidget = new SweeprWidget();
          };
          reInitializeSweeprWidget();
        }
      } catch (error) {
        logger.log('error', 'Error loading sweepr widget:', error);
        setErrorCount(2);
      }
      break;
    case ERROR_CLOSE:
      showAccountVerificationModal.disable();
      showLoginVerificationModal.disable();
      break;
    default:
      logger.log('error', 'Unhandled action', action);
      break;
  }
};
